import 'react-hot-loader';
import React from "react";
import ReactDOM from 'react-dom';
import WelcomeFormContainer from './components/welcomeForm';
import SearchBar from './components/searchbar';
import WbmLink from './components/wbmLink';

var welcomeFormElement = document.getElementById("welcome-form");
if (welcomeFormElement) ReactDOM.render(<WelcomeFormContainer />, welcomeFormElement);

var linkElement = document.getElementById("wbm-link");
if (linkElement) ReactDOM.render(<WbmLink />, linkElement);

var searchBarElement = document.getElementById("welcome-search-bar");
if (searchBarElement) ReactDOM.render(<SearchBar />, searchBarElement);
